<template>
    <v-content>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
                <template v-for="tribune in tribunes">
                    <v-flex v-bind:key="tribune['.key']" xs12>
                        <v-card color="blue-grey darken-2" class="white--text">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ tribune.description }} (Blok {{ tribune.block }})</h3>
                                    <div>{{tribune.places}} plaatsen</div>
                                </div>
                            </v-card-title>
                            <v-card-actions>
                                <v-btn flat color="red" @click="deleteTribune(tribune)">Delete</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn flat dark @click="editTribune(tribune)">Bewerken</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
        <v-btn
                fab
                bottom
                right
                color="pink"
                dark
                fixed
                @click.stop="dialog = !dialog"
        >
            <v-icon>add</v-icon>
        </v-btn>
        <TribuneDialog :dialog="dialog" v-on:closeDialog="dialog = false" :selectedTribune="selectedTribune" />

    </v-content>
</template>

<script>
import { db } from "../../../firebase";
import TribuneDialog from "../../components/TribuneDialog";

export default {
  components: { TribuneDialog },
  name: "Tribunes",
  props: {
    msg: String
  },
  data() {
    return {
      tribunes: [],
      dialog: false,
      selectedTribune: null
    };
  },
  firestore() {
    return {
      tribunes: db.collection("tribunes").orderBy("description")
    };
  },
  methods: {
    deleteTribune: function(tribune) {
      if (confirm("Ben je zeker?")) {
        db.collection("tribunes")
          .doc(tribune[".key"])
          .delete();
      }
    },
    editTribune: function(tribune) {
      this.selectedTribune = tribune;
      this.dialog = !this.dialog;
    }
  }
};
</script>
